import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = { class: "flex w-full gap-1 mb-3" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "flex gap-3 justify-between w-full" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "btn-block hover-child" };
const _hoisted_8 = { class: "color-picker" };
const _hoisted_9 = { class: "flex justify-center mb-2" };
const _hoisted_10 = { class: "flex w-full gap-1" };
const _hoisted_11 = ["onClick"];
import ColorPicker from "primevue/colorpicker";
import ImageLoader from "@/components/uikit/platformComponents/imageLoader/ImageLoader.vue";
import InputNumber from "primevue/inputnumber";
import UDivider from "../../uComponents/UDivider.vue";
import UDropdownMenu from "../../uComponents/UDropdownMenu.vue";
import { ref } from "vue";
import { textVideo } from "@/help/convertVideoLinks";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BlockEditor',
    props: {
        blocks: {
            type: Array,
            default: () => []
        }
    },
    emits: ["update"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const textVideoServises = textVideo();
        const invalid = ref(false);
        const note = ref("");
        const menuItems = ref([
            {
                items: [
                    {
                        label: "Text",
                        type: "text"
                    },
                    {
                        label: "Video",
                        type: "video"
                    },
                    {
                        label: "Image",
                        type: "image"
                    },
                    {
                        label: "Carousel",
                        type: "carousel"
                    }
                ]
            }
        ]);
        const list = ref(props.blocks);
        list.value.forEach((element) => {
            element.key = `${Math.random().toString(36).substr(2, 9)}`;
            if (element.display === undefined) {
                element.display = true;
            }
        });
        function blockUp(index) {
            if (index <= 0) {
                return;
            }
            const [block] = list.value.splice(index, 1);
            list.value.splice(index - 1, 0, block);
            updateData();
        }
        function blockDown(index) {
            if (index >= list.value.length - 1) {
                return;
            }
            const [block] = list.value.splice(index, 1);
            list.value.splice(index + 1, 0, block);
            updateData();
        }
        function blockView(index) {
            if (list.value[index]) {
                list.value[index].display = !list.value[index].display;
            }
            updateData();
        }
        function deleteBlock(index) {
            list.value.splice(index, 1);
            updateData();
        }
        function addBlock(index, type) {
            list.value.splice(index, 0, {
                type: type,
                key: Date.now().toString(),
                display: true
            });
            updateData();
        }
        function updateData() {
            emit("update", list.value);
        }
        function updateColorPicker(value, index) {
            if (list.value[index]) {
                list.value[index].backgroundColor = "#" + value;
                updateData();
            }
        }
        function updateVisualIndent(value, index) {
            if (list.value[index]) {
                list.value[index].visualIndent = value;
                updateData();
            }
        }
        function updateBlock(block, value) {
            if (block.type == "text") {
                block.content = value;
            }
            else if (block.type == "video") {
                if (!value) {
                    invalid.value = true;
                    note.value = textVideoServises;
                }
                else {
                    invalid.value = false;
                    note.value = "";
                }
                block.url = value;
            }
            updateData();
        }
        function updateImageBlock(block, value) {
            if (block.type == "image") {
                block.url = value[0];
            }
            else if (block.type == "carousel") {
                block.urls = value;
            }
            updateData();
        }
        function getBlockData(block) {
            if (block.type == "text") {
                return block.content;
            }
            else if (block.type == "video") {
                return block.url;
            }
        }
        function getImageBlockData(block) {
            if (block.type == "image") {
                return block.url ? [block.url] : [];
            }
            else if (block.type == "carousel") {
                return block.urls;
            }
        }
        return (_ctx, _cache) => {
            const _component_UButton = _resolveComponent("UButton");
            const _component_UInput = _resolveComponent("UInput");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(UDivider),
                    _createVNode(UDropdownMenu, { items: menuItems.value }, {
                        button: _withCtx(({ toggle }) => [
                            _createVNode(_component_UButton, {
                                icon: "plus",
                                type: "icon",
                                severity: "secondary",
                                height: "30px",
                                onClick: toggle
                            }, null, 8, ["onClick"])
                        ]),
                        item: _withCtx(({ item }) => [
                            _createElementVNode("span", {
                                class: "cursor-pointer w-full",
                                onClick: ($event) => (addBlock(0, item.type))
                            }, _toDisplayString(item.label), 9, _hoisted_3)
                        ]),
                        _: 1
                    }, 8, ["items"]),
                    _createVNode(UDivider)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (listItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: listItem.key,
                        class: "flex flex-col gap-3 hover-parent"
                    }, [
                        _createElementVNode("div", {
                            class: "flex gap-3",
                            style: _normalizeStyle({
                                background: listItem.backgroundColor || '#fff',
                                paddingBottom: (listItem.visualIndent || 0) + 'px'
                            })
                        }, [
                            _createElementVNode("div", _hoisted_4, [
                                (listItem.type == 'carousel')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _cache[0] || (_cache[0] = _createElementVNode("div", null, "Carousel", -1)),
                                        _createVNode(ImageLoader, {
                                            "model-value": getImageBlockData(listItem),
                                            type: "file",
                                            "onUpdate:modelValue": (v) => updateImageBlock(listItem, v)
                                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                                    ]))
                                    : (listItem.type == 'image')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _cache[1] || (_cache[1] = _createElementVNode("div", null, "Single Image", -1)),
                                            _createVNode(ImageLoader, {
                                                "model-value": getImageBlockData(listItem),
                                                multiple: false,
                                                type: "file",
                                                "onUpdate:modelValue": (v) => updateImageBlock(listItem, v)
                                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                                        ]))
                                        : (listItem.type == 'text')
                                            ? (_openBlock(), _createBlock(_component_UInput, {
                                                key: 2,
                                                label: "Text",
                                                type: "editor",
                                                "model-value": getBlockData(listItem),
                                                "onUpdate:modelValue": (v) => updateBlock(listItem, v)
                                            }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                            : (listItem.type == 'video')
                                                ? (_openBlock(), _createBlock(_component_UInput, {
                                                    key: 3,
                                                    label: "Video",
                                                    type: "video",
                                                    "model-value": getBlockData(listItem),
                                                    tooltip: _unref(textVideoServises),
                                                    note: note.value,
                                                    invalid: invalid.value,
                                                    "onUpdate:modelValue": (v) => updateBlock(listItem, v)
                                                }, null, 8, ["model-value", "tooltip", "note", "invalid", "onUpdate:modelValue"]))
                                                : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_7, [
                                    (index > 0)
                                        ? (_openBlock(), _createBlock(_component_UButton, {
                                            key: 0,
                                            severity: "secondary",
                                            icon: "arrow-down",
                                            type: "icon",
                                            height: "30px",
                                            class: "mb-2 arrow-up",
                                            onClick: ($event) => (blockUp(index))
                                        }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_UButton, {
                                        severity: "secondary",
                                        icon: listItem?.display ? 'eye-open' : 'eye-close',
                                        type: "icon",
                                        height: "30px",
                                        class: "mb-2",
                                        onClick: ($event) => (blockView(index))
                                    }, null, 8, ["icon", "onClick"]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_unref(ColorPicker), {
                                            "model-value": listItem.backgroundColor || '#ffffff',
                                            "onUpdate:modelValue": ($event) => (updateColorPicker($event, index))
                                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_unref(InputNumber), {
                                            "model-value": listItem.visualIndent || 0,
                                            "show-buttons": "",
                                            "button-layout": "vertical",
                                            style: { "width": "42px" },
                                            min: 0,
                                            max: 80,
                                            "onUpdate:modelValue": ($event) => (updateVisualIndent($event, index))
                                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                                    ]),
                                    _createVNode(_component_UButton, {
                                        severity: "secondary",
                                        icon: "minus",
                                        type: "icon",
                                        height: "30px",
                                        class: "mb-2",
                                        onClick: ($event) => (deleteBlock(index))
                                    }, null, 8, ["onClick"]),
                                    (index + 1 < list.value?.length)
                                        ? (_openBlock(), _createBlock(_component_UButton, {
                                            key: 1,
                                            severity: "secondary",
                                            icon: "arrow-down",
                                            type: "icon",
                                            height: "30px",
                                            class: "mb-2",
                                            onClick: ($event) => (blockDown(index))
                                        }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 4),
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(UDivider),
                            _createVNode(UDropdownMenu, { items: menuItems.value }, {
                                button: _withCtx(({ toggle }) => [
                                    _createVNode(_component_UButton, {
                                        icon: "plus",
                                        severity: "secondary",
                                        type: "icon",
                                        height: "30px",
                                        class: "hover-child",
                                        onClick: toggle
                                    }, null, 8, ["onClick"])
                                ]),
                                item: _withCtx(({ item }) => [
                                    _createElementVNode("span", {
                                        class: "cursor-pointer",
                                        onClick: ($event) => (addBlock(index + 1, item.type))
                                    }, _toDisplayString(item.label), 9, _hoisted_11)
                                ]),
                                _: 2
                            }, 1032, ["items"]),
                            _createVNode(UDivider)
                        ])
                    ]));
                }), 128))
            ]));
        };
    }
});
